import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const DialogContainer = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 420px;
  padding: 24px;
  border-radius: 6px;
`;

export const DialogTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #333;
`;

export const DialogDescription = styled.p`
  margin-top: 12px;
  font-size: 14px;
  color: #666;
`;

export const DialogActions = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  background: transparent;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
